/**
* Text Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Text Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'text-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.text-marquee' ).each( function( key, component ) {
        new Splide( $( component ).find( '.splide--text-marquee' )[0], {
          type: 'loop',
          arrows: false,
          pagination: false,
          autoWidth: true,
          gap: '40px',
          breakpoints: {
            1024: {
              gap: '24px',
            },
          },
        } ).mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'text-marquee', COMPONENT );
} )( app );
